const UserRoles = {
  USER: 'USER',
  ADMIN: 'ADMIN',
  AMBASSADOR: 'AMBASSADOR'
}

export default UserRoles;